import { Dinero as OGDinero, toDecimal } from 'dinero.js';
import { FC } from 'react';
import { InputProps, withField } from '../withField';
import { TextInput } from './TextInput';
import { useCurrencyIdentifier } from '@/utils/price';

export interface CurrencyInputProps {
  placeholder?: string;

  min?: number;
  max?: number;
  regionCode?: string;
}

export const CurrencyInput: FC<InputProps<string | OGDinero<number>> & CurrencyInputProps> = ({
  onChange,
  value,
  id,
  placeholder,
  regionCode
}) => {
  const currencySymbol = useCurrencyIdentifier(regionCode);
  const representation = typeof value === 'string' ? value : toDecimal(value);

  return (
    <TextInput id={id} value={representation} onChange={onChange} placeholder={placeholder} prefix={currencySymbol} />
  );
};

export const CurrencyField = withField<string | OGDinero<number>, CurrencyInputProps>(CurrencyInput);
